export const APP_CONTENT_DESKTOP_WIDTH = '68rem';
export const APP_CONTENT_DESKTOP_WIDE_WIDTH = '82rem';
export const APP_CONTENT_SMALL_DESKTOP_WIDTH = '55rem';
export { SMALL_SCREEN, MEDIUM_SCREEN, LARGE_SCREEN } from './theme';
